module.exports = __webpack_public_path__ + "static/media/profile.5a021ab9.png";